import http from '../utils/http';

export default (flag, options = {}) => {
  const { query = {} } = options;
  const queryParams = {
    ...query,
    ...(flag ? { 'require_flag': flag } : {})
  };

  return http.get('/feature-flag-service/pb/feature-flags/', queryParams);
}
